import { render } from "./SettingsMfaSection.vue?vue&type=template&id=30837dae"
import script from "./SettingsMfaSection.vue?vue&type=script&lang=js"
export * from "./SettingsMfaSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__